import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoginService } from './login.service';
import { catchError } from 'rxjs/operators';
import FileSaver from 'file-saver';
import config from '../config.json';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

    private apiUrl = config.Api.Apiurl;
    private helperUrl = `${this.apiUrl}/helper`;

    constructor(private http: HttpClient, private loginService: LoginService) {}

    /**
     * Convert DOCX file to PDF by sending it to the backend.
     * @param docxFile The DOCX file to be converted.
     * @returns An Observable containing the PDF as a Blob.
     */
    getDJ(data: any): Observable<any> {
        const token = this.getTokenFromCache();
        if (!token) {
            console.error('Token no disponible');
            return throwError(() => new Error('Token no disponible'));
        }

        const headers = new HttpHeaders({
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`
        });

        return this.http.post(`${this.helperUrl}/getDJ`, data,  { headers });
    }

    getFormulario(data: any, tipo: string): Observable<any> {
      const token = this.getTokenFromCache();
      if (!token) {
          console.error('Token no disponible');
          return throwError(() => new Error('Token no disponible'));
      }
      const headers = new HttpHeaders({
        'accept': 'application/json',
        'Authorization': `Bearer ${token}`
      });

      return this.http.post(`${this.helperUrl}/getFormulario?tipo=${tipo}`, data,  { headers });
    }

    getContrato(): Observable<any> {
      const token = this.getTokenFromCache();
      if (!token) {
          console.error('Token no disponible');
          return throwError(() => new Error('Token no disponible'));
      }

      const headers = new HttpHeaders()
          .set('accept', 'application/json')
          .set('Authorization', `Bearer ${token}`);

      return this.http.get<any>(`${this.helperUrl}/getContrato`, { headers }).pipe(
          catchError((error) => {
              console.error('Error al obtener el contrato', error);
              return throwError(() => error);
          })
      );
  }

    /**
     * Genera un UUID para DJ enviando un array de formularios al backend.
     * @param formularios Array de IDs de formularios.
     * @returns Observable con la respuesta del backend.
     */
    generateDJUUID(formularios: number[]): Observable<any> {
      const token = this.getTokenFromCache();
      if (!token) {
        console.error('Token no disponible');
        return throwError(() => new Error('Token no disponible'));
      }

      const headers = new HttpHeaders({
        'accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      });

      const body = { formularios };

      return this.http.post<any>(
        `${this.helperUrl}/generateDJUUID`,
        body,
        { headers }
      ).pipe(
        catchError((error) => {
          console.error('Error al generar DJ UUID', error);
          return throwError(() => error);
        })
      );
    }

/**
 * Envía el token, los formularios y el monto para setear el DJ UUID en el backend.
 * @param tokenDJUUID Token generado para DJ UUID.
 * @param formularios Array de formularios con su estructura.
 * @param monto Monto máximo de retiro de reservas.
 * @returns Observable con la respuesta del backend.
 */
setDJUUID(tokenDJUUID: string, formularios: any[], monto: number): Observable<any> {

  const headers = new HttpHeaders({
    'accept': 'application/json',
    'Content-Type': 'application/json'
  });

  const body = {
    token: tokenDJUUID,
    formularios,
    monto
  };
  console.log('Enviando datos para setear DJ UUID:', body);

  return this.http.post<any>(
    `${this.helperUrl}/setDJUUID`,
    body,
    { headers }
  ).pipe(
    catchError((error) => {
      console.error('Error al setear DJ UUID', error);
      return throwError(() => error);
    })
  );
}

     /**
   * Obtiene el DJ UUID desde el backend usando un token.
   * @param tokenDJUUID Token generado para DJ UUID.
   * @returns Observable con la respuesta del backend.
   */
getDJUUID(tokenDJUUID: string): Observable<any> {
  const headers = new HttpHeaders({
    'accept': 'application/json',
  });
  const params = { token: tokenDJUUID };
  return this.http.get<any>(
    `${this.helperUrl}/getDJUUID`,
    { headers, params }
  )
}

    /**
     * Envía el formulario de contacto al backend.
     * @param data Objeto con los datos del formulario de contacto.
     * @returns Observable con la respuesta del backend.
     */
    sendContactForm(data: {
      nombre: string;
      telefono: string;
      email: string;
      empresa: string;
      ip: string;
    }): Observable<any> {
      const headers = new HttpHeaders({
        'accept': 'application/json',
        'Content-Type': 'application/json'
      });

      return this.http.post<any>(
        `${this.helperUrl}/sendContactForm`,
        data,
        { headers }
      ).pipe(
        catchError((error) => {
          console.error('Error al enviar el formulario de contacto', error);
          return throwError(() => error);
        })
      );
    }

    getMonedas(): Observable<any> {
      const token = this.getTokenFromCache();
      if (!token) {
        console.error('Token no disponible');
        return throwError(() => new Error('Token no disponible'));
      }

      const headers = new HttpHeaders()
        .set('accept', 'application/json')
        .set('Authorization', `Bearer ${token}`);

      return this.http.get<any>(`${this.helperUrl}/getMonedas`, { headers }).pipe(
        catchError(error => {
          console.error('Error al obtener monedas', error);
          return throwError(() => error);
        })
      );
    }

    private handleError(error: any): Observable<never> {
      console.error('Ocurrió un error:', error);
      return throwError(() => new Error('Ocurrió un error; por favor, inténtelo de nuevo más tarde.'));
    }

    private getTokenFromCache(): string | null {
      return this.loginService.getToken();
    }


}
